interface Props {
  volume: number;
  // eslint-disable-next-line no-unused-vars
  volumeChangeHandler: (volume: number) => void;
}

const VolumeProgress: React.FC<Props> = ({ volume, volumeChangeHandler }) => {
  const volumeHundred = `${volume * 100}%`;
  return (
    <div className="nplay-volume-wrap">
      <input
        className="nplay-volume"
        value={volume}
        type="range"
        max="1"
        min="0"
        step="0.001"
        onChange={(v) => {
          volumeChangeHandler(v.target.valueAsNumber);
        }}
      />
      <div className="nplay-volume-track">
        <div
          className="nplay-volume-track-inner"
          style={{ width: volumeHundred }}
        ></div>
      </div>
      <div
        className="nplay-volume-thumb"
        style={{
          left: volumeHundred,
          transform: `translate(-${volumeHundred}, -50%)`,
        }}
      ></div>
    </div>
  );
};

export default VolumeProgress;
